



























































import { defineComponent, PropType, ref, watch } from "@vue/composition-api";
import { SwiperOptions } from "swiper";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import { AiMessage } from "@scrile/api-provider/dist/projects/scrileConnect/AiMessage";
import BaseIcon from "@/components/Base/BaseIcon";
import BaseButton from "@/components/BaseButton";
import BaseIconButton from "@/components/BaseIconButton";
import BaseSpinner from "@/components/BaseSpinner";

export default defineComponent({
  name: "AiMessageGenerate",
  components: { Swiper, SwiperSlide, BaseIconButton, BaseIcon, BaseButton, BaseSpinner },
  props: {
    aiMessages: { type: Array as PropType<AiMessage[]>, default: () => [] },
    generating: { type: Boolean, default: false },
  },
  setup(props, { emit }) {
    const swiperRef = ref();
    const currentSlideIndex = ref(0);

    const swiperOptions: SwiperOptions = {
      slidesPerView: "auto",
      allowTouchMove: true,
      spaceBetween: 24,
      grabCursor: true,
      autoHeight: true,
      pagination: {
        el: ".ai-generate__slider-pagination",
        type: "fraction",
      },
      navigation: {
        prevEl: ".ai-generate__slider-prev",
        nextEl: ".ai-generate__slider-next",
      },
    };

    const onSlideChange = () => {
      if (!swiperRef.value) return;
      currentSlideIndex.value = swiperRef.value.swiperInstance.realIndex;
    };

    const handleUseDraft = () => {
      emit("handlePaste", currentSlideIndex.value);
    };

    watch(
      () => props.aiMessages,
      async () => {
        if (!swiperRef.value) return;
        await swiperRef.value.updateSwiper();
        swiperRef.value.swiperInstance.slideTo(props.aiMessages.length - 1);
      },
      { immediate: true }
    );
    return {
      swiperRef,
      swiperOptions,
      onSlideChange,
      handleUseDraft,
    };
  },
});
